import rfdc from 'rfdc';

export default rfdc();
